import { IOnInit, IPromise } from "angular";
import {
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../../../records/forms/formView";
import fieldHelpers from "../../../../../../ui-formly/fieldHelpers";
import { StateService } from "@uirouter/angularjs";
import { RecordFileTemplateOptions } from "../../../../../../records/forms/formly/types";
import { Machine } from "../../../../models/machine";
import { IFieldArray } from "AngularFormly";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../../records/forms/formly/fieldConfigurationHelpers";
import * as lookupNames from "../../../../configs/lookup";
import { LookupManagementService } from "../../../../../../records/lookup/lookupManagement";
import { vsLookupManagementServiceName as MachineLookupManagementServiceName } from "../../../../../shared/lookups";
import { MachineConfigurationTypeView } from "../../../../models/machineConfigurationType";

export class SingleMachineMoveComponentController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    "$state",
    FieldConfigurationHelperServiceName,
    MachineLookupManagementServiceName,
  ];
  readonly formFields: IFieldArray;
  model: any;
  /* start bindings */
  readonly machine!: Machine;
  /* end binding */

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    fieldConfigurationHelperService: FieldConfigurationHelperService,
    machineLookupManagementService: LookupManagementService
  ) {
    const fileTemplateOptions: RecordFileTemplateOptions = {
      allowMultiple: true,
      label: "Files",
    };
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleDateField({
            key: "Date",
            name: "Date",
            label: "Change Date",
            required: true,
          }),
        ],
        4
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "SlotNumber",
            label: "Machine Number",
            required: true,
          }),
          fieldConfigurationHelperService.selectAsyncField({
            key: "MachineConfigurationTypeId",
            label: "Configuration Type",
            required: true,
            queryUrl: "/api/machines/MachineConfigurationType",
            serverItemMapper: (model: MachineConfigurationTypeView) => {
              return {
                Id: model.Id,
                Name: model.MachineConfigurationTypeName!,
              };
            },
            getDefaultItem: (model: any) => model.MachineConfigurationType,
          }),
          fieldConfigurationHelperService.selectAsyncField({
            queryUrl: "/api/properties",
            getDefaultItem(model) {
              return model.Property;
            },
            label: "Property",
            key: "PropertyId",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "Section",
            name: "Section",
            label: "Section",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "Bank",
            name: "Bank",
            label: "Bank",
            required: true,
          }),
          fieldHelpers.simpleStringField({
            key: "Position",
            name: "Position",
            label: "Position",
            required: true,
          }),
          fieldConfigurationHelperService.lookupField(
            machineLookupManagementService,
            {
              key: "BankConfigId",
              label: "Bank Config",
              objectName: lookupNames.bankConfigName,
            }
          ),
        ],
        4
      ),
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: fileTemplateOptions,
      },
      fieldHelpers.headerField({
        headerText: "Notes",
        key: "NotesHeader",
      }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  $onInit(): void {
    const currentConfiguration = this.machine.Configs?.find(
      (c) => c.CurrentConfiguration
    );
    this.model = {
      MachineId: this.machine.Id,
      SlotNumber: currentConfiguration?.SlotNumber,
      PropertyId: currentConfiguration?.PropertyId,
      Property: currentConfiguration?.Property,
      Files: currentConfiguration?.Files?.map((f: any) => {
        return { Name: f.Name, ContentType: f.ContentType, Url: f.Url };
      }),
      MachineConfigurationTypeId:
        currentConfiguration?.MachineConfigurationTypeId,
      MachineConfigurationType: currentConfiguration?.MachineConfigurationType,
      BankConfigId: currentConfiguration?.BankConfigId,
      BankConfig: currentConfiguration?.BankConfig,
    };
  }

  submit(formViewController: FormViewController): IPromise<void> {
    const machineId = this.machine.Id;
    return this.formViewService
      .submitForm({
        url: `/api/machines/${machineId}/move`,
        formObject: this.model,
        formViewController,
        method: "post",
      })
      .then(() => {
        return this.$state.go("^", undefined, { reload: true });
      })
      .then(() => {});
  }

  cancel(): Promise<void> {
    return this.$state.go("^").then(() => {});
  }
}
